import {GenericInput} from '@hm/fundamental'
import {mdiMagnify} from '@mdi/js'
import {Dispatch, SetStateAction} from 'react'
import {useTranslation} from 'react-i18next'

export interface ShutdownHistorySearchProps {
  setTextFilter: Dispatch<SetStateAction<string>>
  textFilter: string
}

export const ShutdownHistorySearch = ({textFilter, setTextFilter}: ShutdownHistorySearchProps) => {
  const {t} = useTranslation()
  return (
    <GenericInput
      name="refra_static_parts_filter"
      defaultValue={textFilter}
      icon={mdiMagnify}
      placeholder={t('staticParts.filterPlaceholder')}
      onChange={(text) => setTextFilter(text)}
      data-cy="refra_static_parts_filter"
    />
  )
}
